module.exports = __webpack_public_path__ + "img/logo.19c93d20.png";